define('plugin/static-page/StaticPagePlugin',['require','lib/plugin/PluginAbstract','plugin/static-page/collection/StaticPageCollection','plugin/static-page/controller/StaticPageController','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var StaticPageCollection = require('plugin/static-page/collection/StaticPageCollection');
    var StaticPageController = require('plugin/static-page/controller/StaticPageController');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        initialize: function () {

            var pagesCollection = new StaticPageCollection();


            var staticPageRouter = new AppRouter({
                appRoutes: {
                    'page(/:page)': 'index',
                    'page/id/:pageid(/)': 'indexId',
                },
                menuItem: 'static-page',

                controller: new StaticPageController({
                    app: this.getOption('app'),
                    pagesCollection : pagesCollection
                })
            });


        }

    });

});
